import React, { useState, useEffect } from 'react';
import { VOTER_ORANGE, voterIcons } from '../component/voterCardIcons';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../context/AppIdContext';
import '../style/speakSearch.css';
import Header from '../component/header';
import WhatsappSlipButton from '../component/WhatsappSlipButton';
import PracharButton from '../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SchemeVoterList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { appId, language, userId } = useAppId();

    // Extract the scheme_id passed from the previous page
    const scheme_id = location.state?.scheme_id;
    const lang = language || 'en';

    // --- State ---
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: "Scheme Voters List",
            filterPlaceholder: "Filter displayed results by name...",
            loadingData: "Loading Data...",
            noMembers: "No survey records found for this scheme.",
            noIdError: "No Scheme ID provided. Please go back.",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            statusLabel: "Status :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            address: "Address :", // Added translation
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"
        },
        hi: {
            pageTitle: "योजना मतदाता सूची",
            filterPlaceholder: "नाम से प्रदर्शित परिणाम फ़िल्टर करें...",
            loadingData: "डेटा लोड हो रहा है...",
            noMembers: "इस योजना के लिए कोई सर्वेक्षण रिकॉर्ड नहीं मिला।",
            noIdError: "कोई योजना आईडी नहीं दी गई। कृपया वापस जाएं।",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            statusLabel: "स्थिति :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"

        },
        gu: {
            pageTitle: "યોજના મતદાર યાદી",
            filterPlaceholder: "પ્રદર્શિત પરિણામોને નામથી ફિલ્ટર કરો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noMembers: "આ યોજના માટે કોઈ સર્વે રેકોર્ડ મળ્યા નથી.",
            noIdError: "કોઈ યોજના આઈડી પ્રદાન કરવામાં આવી નથી. કૃપા કરીને પાછા જાઓ.",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            statusLabel: "સ્થિતિ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            address: "સરનામું :", // Added translation
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"

        }
    };

    const txt = t[lang];
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };



    // --- Fetch Data ---
    useEffect(() => {
        if (!scheme_id) {
            setLoading(false);
            return;
        }
        if (appId) {
            fetchVoters();
        }
    }, [appId, scheme_id]);

    // Reset to page 1 when searching
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const fetchVoters = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_scheme_wise_survey_voter`, {
                app_id: appId,
                scheme_id: scheme_id
            });

            if (response.data.success && response.data.data) {
                setVoters(response.data.data.result || []);
            } else {
                setVoters([]);
            }
        } catch (error) {
            console.error("Error fetching scheme voters:", error);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    const getStatusStyles = (status) => {
        const s = status ? status.toUpperCase() : '';
        if (s === 'P' || s.includes('POSITIVE')) return { color: '#10b981', label: lang === 'en' ? 'Positive' : 'सकारात्मक' };
        if (s === 'N' || s.includes('NEGATIVE')) return { color: '#ef4444', label: lang === 'en' ? 'Negative' : 'नकारात्मक' };
        if (s === 'D' || s.includes('DOUBTFUL')) return { color: '#f59e0b', label: lang === 'en' ? 'Doubtful' : 'संदिग्ध' };
        if (s === 'C' || s.includes('CANT SAY')) return { color: '#6366f1', label: lang === 'en' ? 'Not Interested' : 'रुचि नहीं' };
        return { color: '#64748b', label: lang === 'en' ? 'Unknown' : 'अज्ञात' };
    };

    // --- Pagination & Filter Logic ---
    const filteredVoters = voters.filter(voter => {
        const fullName = `${voter.eng_f_name || ''} ${voter.eng_surname || ''} ${voter.full_name || ''}`.toLowerCase();
        return fullName.includes(searchTerm.toLowerCase()) ||
            (voter.idcard_no && voter.idcard_no.toLowerCase().includes(searchTerm.toLowerCase()));
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };


    return (
        <div className='app-container p-4 pb-5'>

            {/* Header Component */}
            <Header title={txt.pageTitle} subtitle="" />

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {!scheme_id ? (
                <div className="text-center p-5 mt-4">
                    <h4 className="text-slate fw-bold">{txt.noIdError}</h4>
                    <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>Go Back</button>
                </div>
            ) : (
                <>
                    {/* Subtitle below header */}
                    {!loading && (
                        <div className="subtitle-container mb-4 mt-2">
                            <p className="subtitle-text">
                                Scheme ID: <strong>{scheme_id}</strong> • {filteredVoters.length} {lang === 'en' ? 'records' : 'रिकॉर्ड'}
                            </p>
                        </div>
                    )}

                    {/* --- Professional Search Bar --- */}
                    {voters.length > 0 && (
                        <div className="filter-container-modern mb-4">
                            <div className="search-wrapper-modern">
                                <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <input
                                    className="search-input-modern"
                                    type="text"
                                    placeholder={txt.filterPlaceholder}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                    )}

                    {loading ? (
                        <div className="loader-wrapper text-center p-5">
                            <div className="spinner"></div>
                            <p className="mt-3">{txt.loadingData}</p>
                        </div>
                    ) : (
                        <div style={{ marginBottom: filteredVoters.length > itemsPerPage ? '80px' : '0' }}>
                            <div className="row g-4">
                                {currentItems.length > 0 ? (
                                    currentItems.map((voter, index) => {
                                        const status = getStatusStyles(voter.survey_status || voter.status);
                                        return (
                                            <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                                                <div className="voter-card-clean h-100">
                                                    {/* Name Header */}
                                                    <div className="voter-header">
                                                        <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                                        <span className="voter-name-bold ms-2">
                                                            {voter.full_name || `${voter.eng_f_name || ''} ${voter.eng_surname || ''}`.trim() || 'Unknown'}
                                                        </span>
                                                    </div>

                                                    {/* Details Body */}
                                                    <div className="voter-body position-relative">
                                <div className="info-row">
                                                            <span className="label">{txt.statusLabel}</span>
                                                            <span className="value" style={{ color: status.color, fontWeight: '800' }}>{status.label}</span>
                                                        </div>
                                                        <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{voter.eng_m_name || "N/A"}</span></div>
                                                        <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                                        <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{voter.slnoinpart || "N/A"}</span></div>
                                                        <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span className="label">{txt.mobile}</span>
                                                            <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                                            <svg
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setEditingVoter(voter);
                                                                    setNewMobile(voter.contact_no || '');
                                                                    setIsEditMobileOpen(true);
                                                                }}
                                                                style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                                                fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                                            >
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                            </svg>
                                                        </div>
                                                        <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "N/A"}</span></div>
                                                        <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{voter.part_no || voter.booth_no || "N/A"}</span></div>
                                                        <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no || "N/A"}</span></div>
                                                        <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{voter.eng_polling_location || "-"}</span></div>

                                                        {voter.not_available_reason && (
                                                            <div className="info-row mt-1" style={{ background: '#fff7ed', padding: '4px 8px', borderRadius: '4px' }}>
                                                                <span className="label" style={{ color: '#9a3412' }}>Reason :</span>
                                                                <span className="value" style={{ color: '#9a3412' }}>{voter.not_available_reason}</span>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="voter-actions">
                                                        <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                                    alert("Mobile number is not available for this voter.");
                                                                }
                                                                else {
                                                                    window.open(`tel:${voter.contact_no}`, '_blank');
                                                                }
                                                            }}

                                                        />
                                                        <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(voter)} />
                                                       <WhatsappSlipButton voter={voter} />
                                                        <PracharButton voter={voter} />
                                                        {/* PRINTER NAVIGATION */}
                                                        <ActionButton
                                                            icon={voterIcons.print} color={VOTER_ORANGE}
                                                            label={txt.print}
                                                            onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                                        />
                                                        <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center text-muted p-5 w-100">{txt.noMembers}</div>
                                )}
                            </div>

                            {/* --- FIXED PAGINATION CONTROLS --- */}
                            {filteredVoters.length > itemsPerPage && (
                                <div className="pagination-wrapper fixed-bottom-pagination">
                                    <div className="pagination-content">
                                        <button
                                            className="pagination-nav-btn"
                                            onClick={() => paginate(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                                        </button>

                                        <div className="page-numbers">
                                            {getPageNumbers().map((number, index) => (
                                                <React.Fragment key={index}>
                                                    {number === '...' ? (
                                                        <span className="page-dots">...</span>
                                                    ) : (
                                                        <button
                                                            className={`page-num-btn ${currentPage === number ? 'active' : ''}`}
                                                            onClick={() => paginate(number)}
                                                        >
                                                            {number}
                                                        </button>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </div>

                                        <button
                                            className="pagination-nav-btn"
                                            onClick={() => paginate(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}

            <style jsx>{`
                /* Subtitle Styles - Option 7: Gradient Line */
                .subtitle-container {
                    margin-top: 8px;
                    margin-bottom: 20px;
                    position: relative;
                }
                .subtitle-text {
                    font-size: 15px;
                    color: #334155;
                    margin: 0 0 10px 0;
                    font-weight: 600;
                }
                .subtitle-text strong {
                    color: #1e40af;
                    font-weight: 700;
                }
                .subtitle-container::after {
                    content: "";
                    display: block;
                    width: 60px;
                    height: 3px;
                    background: linear-gradient(to right, #2563eb, #60a5fa);
                    border-radius: 3px;
                    margin-top: 4px;
                }

                /* --- SEARCH BAR STYLE --- */
                .filter-container-modern { display: flex; justify-content: flex-start; align-items: center; }
                .search-wrapper-modern { position: relative; width: 100%; max-width: 450px; }
                .search-icon-modern { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); width: 20px; height: 20px; color: #94a3b8; pointer-events: none; z-index: 1; }
                .search-input-modern { width: 100%; padding: 12px 16px 12px 42px; border: 1px solid #e2e8f0; border-radius: 12px; font-size: 14px; color: #1e293b; background-color: #ffffff; outline: none; transition: all 0.2s ease; box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
                .search-input-modern:focus { border-color: #2563eb; box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); }

                @media (max-width: 640px) {
                    .search-wrapper-modern { max-width: 100%; }
                    .subtitle-text { font-size: 14px; }
                    .subtitle-container::after { width: 50px; height: 2px; }
                }

                .btn-reset { background: none; border: none; cursor: pointer; padding: 0; display: flex; flex-direction: column; align-items: center; }
                .spinner { width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                .btn-back { background-color: white; color: #64748b; border: 1px solid #e2e8f0; padding: 6px 14px; border-radius: 8px; font-weight: 600; cursor: pointer; display: flex; align-items: center; transition: 0.2s; font-size: 0.9rem; }
                .btn-back:hover { background-color: #f8fafc; color: #1e293b; }
                
                /* Fixed Pagination Styles */
                .fixed-bottom-pagination { 
                    position: fixed; 
                    bottom: 0; 
                    left: 0; 
                    width: 100%; 
                    display: flex; 
                    justify-content: center; 
                    padding: 15px 0 20px 0; 
                    background: transparent; 
                    z-index: 1000;
                }
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; position: sticky; bottom: 20px; z-index: 50; pointer-events: none; }
                .pagination-content { background: white; border: 1px solid #E2E8F0; border-radius: 50px; padding: 8px 16px; display: flex; align-items: center; gap: 10px; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); pointer-events: auto; }
                .pagination-nav-btn { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; background: transparent; border: none; color: #2563EB; cursor: pointer; transition: all 0.2s; }
                .pagination-nav-btn:hover:not(:disabled) { background: #EFF6FF; }
                .pagination-nav-btn:disabled { color: #CBD5E1; cursor: not-allowed; }
                .page-numbers { display: flex; gap: 5px; align-items: center; }
                .page-num-btn { width: 32px; height: 32px; border-radius: 50%; border: 1px solid transparent; background: transparent; color: #475569; font-weight: 600; font-size: 14px; cursor: pointer; transition: all 0.2s; }
                .page-num-btn:hover { border-color: #2563EB; color: #2563EB; }
                .page-num-btn.active { background-color: #2563EB; color: white; border-color: #2563EB; box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3); }
                .page-dots { color: #94A3B8; font-weight: bold; padding: 0 4px; }
            `}</style>
        </div>
    );
};

// Reusable ActionButton
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default SchemeVoterList;